import ResponsiveTopBar from './ResponsiveTopBar.view';

export default ResponsiveTopBar;
